import weatherService from "@/api/alert-api/weather.service";
import historicalService from "@/api/forecast-api/historical.service";
import moment from "moment";
import "moment-duration-format";
import { snackbar } from "@/core/controller/snackbar_controller";

const state = {
  historicalCountieData: [],
  weatherData: [],
  recordedDataFromTelmetryStations: [],
  lightningCountData: [],
  historicalRegionalData: [],
  historicalAgencyQtdeUc: [],
  historicalAgencyData: [],
  historicalFullData: [],
  historicalFullRegional: [],
  historicalRegionalQtdeUc: [],
  historicalForecastsData: [],
  listCities: [],
  hsitoricalRegionalCitiesSummary: [],
  weatherAgenciesOnAlertsData: [],
  weatherTableData: [],
};

const mutations = {
  setHistoricalCountieData(state, data) {
    state.historicalCountieData = data ? data : [];
  },
  setHistoricalRegionalData(state, data) {
    state.historicalRegionalData = data ? data : [];
  },
  setWeatherData(state, data) {
    state.weatherData = data ? data : [];
  },

  setHistoricalAgencyData(state, data) {
    state.historicalAgencyData = data ? data : [];
  },
  setRecordedDataFromTelmetryStations(state, data) {
    state.recordedDataFromTelmetryStations = data ? data : [];
  },

  setLightnigCountData(state, data) {
    state.lightningCountData = data ? data : [];
  },
  setHistoricalAgencyQtdeUc(state, data) {
    state.historicalAgencyQtdeUc = data ? data : [];
  },
  setHistoricalRegionalQtdeUc(state, data) {
    state.historicalRegionalQtdeUc = data ? data : [];
  },

  setHistoricalFullData(state, data) {
    state.historicalFullData = data ? data : [];
  },
  setHistoricalFullRegionalData(state, data) {
    state.historicalFullRegional = data ? data : [];
  },

  setHistoricalForecastsData(state, data) {
    state.historicalForecastsData = data ? data : [];
  },

  setListCities(state, data) {
    state.listCities = data ? data : [];
  },

  setRegionalCitiesDailySummary(state, data) {
    state.hsitoricalRegionalCitiesSummary = data ? data : [];
  },

  setWeatherAgenciesOnAlertsData(state, data) {
    state.weatherAgenciesOnAlertsData = data ? data : [];
  },

  setWeatherTableData(state, data) {
    state.weatherTableData = data ? data : [];
  },
};

const actions = {
  async fetchWeatherData({ commit }, data) {
    const { regionalId, date } = data;
    const initialDate = moment(date).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

    const finalDate = moment(date)
      .utc()
      .add(1, "days")
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    const response = await weatherService.getHistoricalWeatherAlerts(
      regionalId,
      initialDate,
      finalDate
    );

    const intensityLabel = (intensity) => {
      if (intensity == "T0") {
        return "SEM ALERTA";
      }
      if (intensity == "T1" || intensity == "T2") {
        return "FRACO";
      }
      if (intensity == "T3" || intensity == "T4") {
        return "MODERADO";
      }
      if (intensity == "T5" || intensity == "T6") {
        return "FORTE";
      }
      if (intensity == "T7" || intensity == "T8") {
        return "INTENSO";
      }
      if (intensity == "T9" || intensity == "T10") {
        return "EXTREMO";
      }
    };

    const validity = (validity, color) => {
      if (validity === "até 1h hora") {
        return {
          pattern: {
            path: "M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11",
            width: 8,
            height: 8,
            color: color,
          },
        };
      }
      if (validity === "acima de 1h") {
        return {
          pattern: {
            path: "M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11",
            width: 8,
            height: 8,
            color: color,
            patternTransform: "rotate(45)",
          },
        };
      }
    };

    let modelData = [
      {
        name: "T0",
        color: "#DCE775",
        borderColor: "#DCE775",
        data: [],
      },
      {
        name: "T1 e T2",
        color: "#CDDC39",
        borderColor: "#CDDC39",
        data: [],
      },
      {
        name: "T3 e T4",
        color: "#FDE047",
        borderColor: "#FDE047",
        data: [],
      },
      {
        name: "T5 e T6",
        color: "#FF9F00",
        borderColor: "#FF9F00",
        data: [],
      },
      {
        name: "T7 e T8",
        color: "#FB2E33",
        borderColor: "#FB2E33",
        data: [],
      },
      {
        name: "T9 e T10",
        color: "#D40D12",
        borderColor: "#D40D12",
        data: [],
      },
    ];

    response.data.forEach((el) => {
      for (let d of modelData) {
        const testIfMatch = d.name.split(" e ");
        testIfMatch.forEach((c) => {
          if (c == el.eventName) {
            const alertDuration = moment(el.alertEndForecast).diff(
              moment(el.alertStart)
            );
            const validityTest = moment
              .duration(alertDuration)
              .format("HH:mm")
              .split(":");
            const validityText =
              parseInt(validityTest[0]) <= 1 ? "até 1h hora" : "acima de 1h";
            const element = {
              name: moment(el.alertStart).format("HH:mm"),
              y: el.alertArea,
              label: el.eventName,
              validity: validityText,
              validityLabel: moment.duration(alertDuration).format("HH:mm"),
              intensityLabel: intensityLabel(el.eventName),
              color: validity(validityText, d.color),
              ...el,
            };
            d.data.push(element);
          }
        });
      }
    });
    const finalData = modelData.filter((item) => item.data.length > 0);
    commit("setWeatherData", finalData);
  },

  async fetchDailyHistoricalCountieData({ commit }, data) {
    const payload = {
      date: data.date,
      runtimeHourMinute: data.runtimeHourMinute
        ? data.runtimeHourMinute
        : "00:00",
      locationIds: [data.location.cityId],
      runtimes: data.runtimes ? data.runtimes : [],
      results: ["high", "medium", "low", "zero"],
    };
    const response = await historicalService.getDailyCountiesInterruptions(
      payload
    );
    commit("setHistoricalCountieData", response.data);
  },
  async fetchHourlyHistoricalCountieData({ commit }, data) {
    try {
      let payload = {};
      if (data.typeSelected == "graphic") {
        const localDate = moment
          .utc(data.date)
          .hour(data.hour)
          .format("YYYY-MM-DD HH:mm");
        const toUtcDate = moment(localDate)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        payload = {
          datetime: toUtcDate,
          locationIds: [data.location.cityId],
          runtimes: data.runtimes ? data.runtimes : [],
          results: ["high", "medium", "low", "zero"],
        };
      }

      if (data.typeSelected == "table") {
        payload = {
          datetime: data.date,
          locationIds: [data.location.cityId],
          runtimes: [],
          results: ["high", "medium", "low", "zero"],
        };
      }

      const response = await historicalService.getHourlyCountiesInterruptions(
        payload
      );
      commit("setHistoricalCountieData", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchDailyHistoricalRegionalData({ commit }, data) {
    const payload = {
      date: data.date,
      runtimeHourMinute: data.runtimeHourMinute
        ? data.runtimeHourMinute
        : "00:00",
      regionalIds: [data.location.id],
      runtimes: data.runtimes ? data.runtimes : [],
      // results: [],
    };

    const response = await historicalService.getDailyRegionalsInterruptions(
      payload
    );

    commit("setHistoricalRegionalData", response.data);
  },

  async fetchDailyHistoricalAgencyData({ commit }, data) {
    const payload = {
      date: data.date,
      runtimeHourMinute: data.runtimeHourMinute
        ? data.runtimeHourMinute
        : "00:00",
      agencyIds: [data.location.id],
      runtimes: data.runtimes ? data.runtimes : [],
      results: ["high", "medium", "low", "zero"],
    };

    const response = await historicalService.getDailyAgenciesInterruptions(
      payload
    );

    const responseCityCopel = await historicalService.getCityCopel({
      agencyIds: [data.location.id],
    });

    const historicalDataCouties = [];

    response.data.forEach((e, index) => {
      responseCityCopel.data.forEach((el) => {
        if (e.locationId == el.locationId) {
          historicalDataCouties[index] = e;
          historicalDataCouties[index].locationName = el.locationName;
          historicalDataCouties[index].qtdeuc = el.qtdeuc;
        }
      });
    });

    commit("setHistoricalAgencyData", historicalDataCouties);
  },

  async fetchHourlyHistoricalRegionalData({ commit }, data) {
    let payload = {};

    if (data.typeSelected == "graphic") {
      const localDate = moment
        .utc(data.date)
        .hour(data.hourStart)
        .format("YYYY-MM-DD HH:mm");

      const toUtcDate = moment(localDate)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      payload = {
        datetime: toUtcDate,
        regionalIds: [data.location.id],
        runtimes: data.runtimes,
        results: [],
      };
    }

    if (data.typeSelected == "table") {
      payload = {
        datetime: data.date,
        regionalIds: [data.location.id],
        runtimes: [],
        results: [],
      };
    }

    const response = await historicalService.getHourlyRegionalsInterruptions(
      payload
    );

    commit("setHistoricalRegionalData", response.data);
  },

  async fetchHourlyHistoricalAgencyData({ commit }, data) {
    try {
      let payload = {};
      if (data.typeSelected == "graphic") {
        const localDate = moment
          .utc(data.date)
          .hour(data.hour)
          .format("YYYY-MM-DD HH:mm");
        const toUtcDate = moment(localDate)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        payload = {
          datetime: toUtcDate,
          agencyIds: [data.location.id],
          runtimes: data.runtimes ? data.runtimes : [],
          results: [],
        };
      }

      if (data.typeSelected == "table") {
        payload = {
          datetime: data.date,
          agencyIds: [data.location.id],
          runtimes: [],
          results: [],
        };
      }

      const response = await historicalService.getHourlyAgenciesInterruptions(
        payload
      );
      const responseCityCopel = await historicalService.getCityCopel({
        agencyIds: [data.location.id],
      });

      const historicalDataCouties = [];

      response.data.forEach((e, index) => {
        responseCityCopel.data.forEach((el) => {
          if (e.locationId == el.locationId) {
            historicalDataCouties[index] = e;
            historicalDataCouties[index].locationName = el.locationName;
            historicalDataCouties[index].qtdeuc = el.qtdeuc;
          }
        });
      });

      commit("setHistoricalAgencyData", historicalDataCouties);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchDailyHistoricalFullData({ commit }, data) {
    const payload = {
      date: data.date,
      runtimeHourMinute: data.runtimeHourMinute
        ? data.runtimeHourMinute
        : "00:00",
      regionalIds: [data.location.regionalId],
      runtimes: data.runtimes ? data.runtimes : [],
      results: [],
    };
    const response = await historicalService.getDailyRegionalsInterruptions(
      payload
    );

    commit("setHistoricalFullData", response.data);
  },

  async fetchHourlyHistoricalFullData({ commit }, data) {
    const localDate = moment
      .utc(data.date)
      .hour(data.hour)
      .format("YYYY-MM-DD HH:mm");
    const toUtcDate = moment(localDate)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    const payload = {
      datetime: toUtcDate,
      regionalIds: [data.location.regionalId],
      runtimes: data.runtimes ? data.runtimes : [],
      results: [],
    };
    const response = await historicalService.getHourlyRegionalsInterruptions(
      payload
    );
    commit("setHistoricalFullData", response.data);
  },

  async fetchDailyHistoricalFullRegionalData({ commit }, data) {
    let payload = {};
    if (data.typeHistoricalSelected == 0) {
      payload = {
        date: data.date,
        runtimeHourMinute: data.runtimeHourMinute
          ? data.runtimeHourMinute
          : "00:00",
        regionalIds: [],
        runtimes: data.runtimes ? data.runtimes : [],
      };
    }

      if (data.typeHistoricalSelected == 1) {
        payload = {
          date: data.date,
          runtimeHourMinute:"00:00",
          regionalIds: [data.location.id],
          runtimes: data.runtimes ? data.runtimes : [],
        };
    }
    const response = await historicalService.getDailyFullRegionalsInterruptions(
      payload
    );

    commit("setHistoricalFullRegionalData", response.data);
  },

  async fetchHourlyHistoricalFullRegionalData({ commit }, data) {
    ///  const  diffrun = data.hour % 3

    const localDate = moment
      .utc(data.date)
      .hour(data.hour)
      .format("YYYY-MM-DD HH:mm");
    const toUtcDate = moment(localDate)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    const payload = {
      datetime: toUtcDate,
      regionalIds: [],
      runtimes: data.runtimes ? data.runtimes : [],
      results: [],
    };
    const response =
      await historicalService.getHourlyFullRegionalsInterruptions(payload);
    commit("setHistoricalFullRegionalData", response.data);
  },

  async fetchDailyHistoricalForecastsRegionals({ commit }, data) {
    try {
      const payload = {
        date: data.date,
        runtimeHourMinute: data.runtimeHourMinute
          ? data.runtimeHourMinute
          : "00:00",
        regionalIds: [data.location.id],
        runtimes: data.runtimes ? data.runtimes : [],
      };

      const response = await historicalService.getDailyForecastsRegionals(
        payload
      );
      commit("setHistoricalForecastsData", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchHourlyHistoricalForecastsRegionals({ commit }, data) {
    try {
      let payload = {};
      if (data.typeSelected == "graphic") {
        const runtimes = [];
        for (let datetime of data.runtimes) {
          const time = moment(datetime).format("HH:mm");
          const hour = parseInt(time.split(":")[0]);
          const diffRun = (hour % 3) + 3;
          const hourlyRound = hour - diffRun;
          const localDate = moment
            .utc(data.date)
            .hour(hourlyRound)
            .format("YYYY-MM-DD HH:mm");
          const toUtcDate = moment(localDate)
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
          runtimes.push(toUtcDate);
        }
        const localDate = moment
          .utc(data.date)
          .hour(data.hour)
          .format("YYYY-MM-DD HH:mm");
        const toUtcDate = moment(localDate)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        payload = {
          datetime: toUtcDate,
          regionalIds: [data.location.id],
          // runtimes: data.runtimes ? data.runtimes : [],

          runtimes: runtimes,
          results: [],
        };
      }

      if (data.typeSelected == "table") {
        payload = {
          datetime: data.date,
          regionalIds: [data.location.id],
          results: [],
        };
      }

      const response = await historicalService.getHourlyForecastsRegionals(
        payload
      );
      commit("setHistoricalForecastsData", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchDailyHistoricalForecastsAgencies({ commit }, data) {
    try {
      const payload = {
        date: data.date,
        runtimeHourMinute: data.runtimeHourMinute
          ? data.runtimeHourMinute
          : "00:00",
        agencyIds: [data.location.id],
        runtimes: data.runtimes ? data.runtimes : [],
      };

      const response = await historicalService.getDailyForecastsAgencies(
        payload
      );
      commit("setHistoricalForecastsData", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchHourlyHistoricalForecastsAgencies({ commit }, data) {
    try {
      let payload = {};
      if (data.typeSelected == "graphic") {
        const runtimes = [];
        for (let datetime of data.runtimes) {
          const time = moment(datetime).format("HH:mm");
          const hour = parseInt(time.split(":")[0]);
          const diffRun = (hour % 3) + 3;

          const hourlyRound = hour - diffRun;
          const localDate = moment
            .utc(data.date)
            .hour(hourlyRound)
            .format("YYYY-MM-DD HH:mm");
          const toUtcDate = moment(localDate)
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

          runtimes.push(toUtcDate);
        }
        const localDate = moment
          .utc(data.date)
          .hour(data.hour)
          .format("YYYY-MM-DD HH:mm");
        const toUtcDate = moment(localDate)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        payload = {
          datetime: toUtcDate,
          agencyIds: [data.location.id],
          /*   runtimes: data.runtimes ? data.runtimes : [], */
          runtimes: runtimes,
          results: [],
        };
      }

      if (data.typeSelected == "table") {
        payload = {
          datetime: data.date,
          agencyIds: [data.location.id],
          results: [],
        };
      }

      const response = await historicalService.getHourlyForecastsAgencies(
        payload
      );
      commit("setHistoricalForecastsData", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchDailyHistoricalForecastsCouties({ commit }, data) {
    try {
      const payload = {
        date: data.date,
        runtimeHourMinute: data.runtimeHourMinute
          ? data.runtimeHourMinute
          : "00:00",
        locationIds: [data.location.cityId],
        runtimes: data.runtimes ? data.runtimes : [],
      };

      const response = await historicalService.getDailyForecastsCouties(
        payload
      );
      commit("setHistoricalForecastsData", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchHourlyHistoricalForecastsCouties({ commit }, data) {
    try {
      let payload = {};
      if (data.typeSelected == "graphic") {
        const runtimes = [];
        for (let datetime of data.runtimes) {
          const time = moment(datetime).format("HH:mm");
          const hour = parseInt(time.split(":")[0]);
          const diffRun = (hour % 3) + 3;

          const hourlyRound = hour - diffRun;
          const localDate = moment
            .utc(data.date)
            .hour(hourlyRound)
            .format("YYYY-MM-DD HH:mm");
          const toUtcDate = moment(localDate)
            .utc()
            .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

          runtimes.push(toUtcDate);
        }
        const localDate = moment
          .utc(data.date)
          .hour(data.hour)
          .format("YYYY-MM-DD HH:mm");
        const toUtcDate = moment(localDate)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        payload = {
          datetime: toUtcDate,
          locationIds: [data.location.cityId],
          /*  runtimes: data.runtimes ? data.runtimes : [], */
          runtimes: runtimes,
          results: [],
        };
      }

      if (data.typeSelected == "table") {
        payload = {
          datetime: data.date,
          locationIds: [data.location.cityId],
          results: [],
        };
      }

      const response = await historicalService.getHourlyForecastsCouties(
        payload
      );
      commit("setHistoricalForecastsData", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },
  async fetchRecordedDataFromTelmetryStationsDaily({ commit }, data) {
    try {
      const payload = {
        startDate: moment(data.date).utc().format("YYYY-MM-DD"),
        endDate: moment(data.date).utc().format("YYYY-MM-DD"),
        regionalId: data.regionalId,
      };

      const response = await historicalService.getRegionalDailySummary(payload);
      commit("setRecordedDataFromTelmetryStations", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchRecordedDataFromTelmetryStationsHourly({ commit }, data) {
    try {
      const payload = {
        startDatetime: data.date,
        endDatetime: data.date,
        regionalId: data.regionalId,
      };

      const response = await historicalService.getRegionalDailySummary(payload);

      commit("setRecordedDataFromTelmetryStations", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchRecordedDataFromTelmetryStationsDailyAgency({ commit }, data) {
    try {
      const payload = {
        startDate: data.date,
        endDate: data.date,
        agencyId: data.agencyId,
      };
      const response = await historicalService.getAgencyDailySummary(payload);
      commit("setRecordedDataFromTelmetryStations", response.data);
    } catch (error) {
      /*   snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      }); */
    }
  },

  async fetchRecordedDataFromTelmetryStationsDailyCity({ commit }, data) {
    try {
      const payload = {
        startDate: data.date,
        endDate: data.date,
        cityId: data.cityId,
      };
      const response = await historicalService.getCityDailySummary(payload);

      commit("setRecordedDataFromTelmetryStations", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchRecordedDataFromTelmetryStationsHourlyRegional({ commit }, data) {
    try {
      const localDate = moment
        .utc(data.date)
        .hour(data.hour)
        .format("YYYY-MM-DD HH:mm");
      const toUtcDate = moment(localDate)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const payload = {
        startDatetime: toUtcDate,
        endDatetime: toUtcDate,
        regionalId: data.location.id,
      };

      const response = await historicalService.getRegionalHourlySummary(
        payload
      );

      commit("setRecordedDataFromTelmetryStations", response.data);
    } catch (error) {
      /*   snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      }); */
    }
  },

  async fetchRecordedDataFromTelmetryStationsHourlyAgency({ commit }, data) {
    try {
      const localDate = moment
        .utc(data.date)
        .hour(data.hour)
        .format("YYYY-MM-DD HH:mm");
      const toUtcDate = moment(localDate)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      const payload = {
        startDatetime: toUtcDate,
        endDatetime: toUtcDate,
        agencyId: data.location.id,
      };

      const response = await historicalService.getAgencyHourlySummary(payload);

      commit("setRecordedDataFromTelmetryStations", response.data);
    } catch (error) {
      /*   snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      }); */
    }
  },

  async fetchRecordedDataFromTelmetryStationsHourlyCity({ commit }, data) {
    try {
      let payload = {};
      if (data.typeSelected == "graphic") {
        const localDate = moment
          .utc(data.date)
          .hour(data.hour)
          .format("YYYY-MM-DD HH:mm");
        const toUtcDate = moment(localDate)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

        payload = {
          startDatetime: toUtcDate,
          endDatetime: toUtcDate,
          cityId: data.location.cityId,
        };
      }

      if (data.typeSelected == "table") {
        payload = {
          startDatetime: data.date,
          endDatetime: data.date,
          cityId: data.location.cityId,
        };
      }

      const response = await historicalService.getCityHourlySummary(payload);
      commit("setRecordedDataFromTelmetryStations", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchDailyLightningCountRegional({ commit }, data) {
    try {
      const localDate = moment.utc(data.date).format("YYYY-MM-DD HH:mm");

      const toUtcDate = moment(localDate).utc().format("YYYY-MM-DD");

      const payload = {
        start_date: toUtcDate,
        end_date: toUtcDate,
        regionalIds: data.regionalIds ? [data.regionalIds] : [],
      };

      const response = await historicalService.getDailyLightningCountRegional(
        payload
      );

      const regionalLabel = (regional) => {
        if (regional == 'DOCCMN') {
          return 'DOCCMN';
        }
        if (regional == 'DOCCSL') {
          return 'DOCCSL';
        }
        if (regional == 'DOCMSL') {
          return 'DOCMSL';
        }
        if (regional == 'DOCNRO') {
          return 'DOCNRO';
        }
        if (regional == 'DOCNRT') {
          return 'DOCNRT';
        }
        if (regional == 'DOCOST') {
          return 'DOCOST';
        }
        if (regional == 'DOCSUD') {
          return 'DOCSUD';
        }
      };

      const lightnigColor = [
        "#265E7D",
        "#2C81AF",
        "#38A0D9",
        "#6EC8FA",
        "#93D1FF",
      ];

      const lightningSum = response.data.map((e, i) => {
        return {
          y: e.sumRegional,
          name: regionalLabel(e.regional),
          sliced: i == 0 ? true : false,
          color: lightnigColor[i],
          type: "regional",
          date: e.date,
          sumData: e.sumRegional,
        };
      });
      lightningSum.type = "regional";

      commit("setLightnigCountData", lightningSum);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchHourlyLightningCountRegional({ commit }, data) {
    try {
      const localDate = moment
        .utc(data.date)
        .hour(data.hour)
        .format("YYYY-MM-DD HH:mm");
      const toUtcDate = moment(localDate)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const payload = {
        start_datetime: toUtcDate,
        end_datetime: toUtcDate,
      };
      const response = await historicalService.getHourlyLightningCountRegional(
        payload
      );

      const regionalLabel = (regional) => {
        if (regional == 'DOCCMN') {
          return 'DOCCMN';
        }
        if (regional == 'DOCCSL') {
          return 'DOCCSL';
        }
        if (regional == 'DOCMSL') {
          return 'DOCMSL';
        }
        if (regional == 'DOCNRO') {
          return 'DOCNRO';
        }
        if (regional == 'DOCNRT') {
          return 'DOCNRT';
        }
        if (regional == 'DOCOST') {
          return 'DOCOST';
        }
        if (regional == 'DOCSUD') {
          return 'DOCSUD';
        }
      };

      const lightnigColor = [
        "#265E7D",
        "#2C81AF",
        "#38A0D9",
        "#6EC8FA",
        "#93D1FF",
      ];

      const lightningSum = response.data.map((e, i) => {
        return {
          y: e.sumRegional,
          name: regionalLabel(e.regional),
          sliced: i == 0 ? true : false,
          color: lightnigColor[i],
          sumData: e.sumRegional,
          datetime: e.datetime,
        };
      });
      lightningSum.type = "regional";

      commit("setLightnigCountData", lightningSum);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchDailyLightningCountAgency({ commit }, data) {
    try {
      const localDate = moment.utc(data.date).format("YYYY-MM-DD HH:mm");

      const toUtcDate = moment(localDate).utc().format("YYYY-MM-DD");

      const payload = {
        start_date: toUtcDate,
        end_date: toUtcDate,
        regionalIds: data.regionalId ? [data.regionalId] : [],
        agencyIds: data.agencyIds ? [data.agencyIds] : [],
      };

      const response = await historicalService.getDailyLightningCountAgency(
        payload
      );

      const lightnigColor = [
        "#265E7D",
        "#265E7D",
        "#2C81AF",
        "#38A0D9",
        "#38A0D9",
        "#6EC8FA",
        "#93D1FF",
        "#B7E2FF",
        "#E4F3FF",
      ];

      const lightningSum = response.data.map((e, i) => {
        return {
          y: e.sumAgency,
          name: e.agencyIds[0],
          sliced: i == 0 ? true : false,
          color: lightnigColor[i],
          sumData: e.sumAgency,
          date: e.date,
        };
      });
      lightningSum.type = "agency";
      commit("setLightnigCountData", lightningSum);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchHourlyLightningCountAgency({ commit }, data) {
    try {
      const localDate = moment
        .utc(data.date)
        .hour(data.hour)
        .format("YYYY-MM-DD HH:mm");
      const toUtcDate = moment(localDate)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const payload = {
        start_datetime: toUtcDate,
        end_datetime: toUtcDate,
        regionalIds: data.regionalId ? [data.regionalId] : [],
        agencyIds: data.agencyIds ? [data.agencyIds] : [],
      };

      const response = await historicalService.getHourlyLightningCountAgency(
        payload
      );
      const lightnigColor = [
        "#265E7D",
        "#265E7D",
        "#2C81AF",
        "#38A0D9",
        "#38A0D9",
        "#6EC8FA",
        "#93D1FF",
        "#B7E2FF",
        "#E4F3FF",
      ];

      const lightningSum = response.data.map((e, i) => {
        return {
          y: e.sumAgency,
          name: e.agencyIds[0],
          sliced: i == 0 ? true : false,
          color: lightnigColor[i],
          sumData: e.sumAgency,
          datetime: e.datetime,
        };
      });
      lightningSum.type = "agency";

      commit("setLightnigCountData", lightningSum);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchDailyLightningCountCity({ commit }, data) {
    try {
      const localDate = moment.utc(data.date).format("YYYY-MM-DD HH:mm");

      const toUtcDate = moment(localDate).utc().format("YYYY-MM-DD");
      const payload = {
        start_date: toUtcDate,
        end_date: toUtcDate,
        agencyIds: data.agencyIds ? data.agencyIds : [],
        // locationIds: data.locationIds ? [data.locationIds] : [],
      };

      const response = await historicalService.getDailyLightningCountCity(
        payload
      );
      const lightnigColor = [
        "#265E7D",
        "#2C81AF",
        "#38A0D9",
        "#6EC8FA",
        "#93D1FF",
        "#B7E2FF",
        "#E4F3FF",
      ];

      const lightningSum = response.data.map((e, i) => {
        return {
          y: e.sumCity,
          name: e.locationName,
          sliced: i == 0 ? true : false,
          color: lightnigColor[i],
          sumData: e.sumCity,
          date: e.date,
        };
      });

      lightningSum.type = "city";

      commit("setLightnigCountData", lightningSum);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchHourlyLightningCountCity({ commit }, data) {
    try {
      const localDate = moment
        .utc(data.date)
        .hour(data.hour)
        .format("YYYY-MM-DD HH:mm");
      const toUtcDate = moment(localDate)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const payload = {
        start_datetime: toUtcDate,
        end_datetime: toUtcDate,
        agencyIds: data.location.agencies ? data.location.agencies : [],
        locationIds: data.locationIds ? [data.locationIds] : [],
      };

      const response = await historicalService.getHourlyLightningCountCity(
        payload
      );
      const lightnigColor = [
        "#265E7D",
        "#2C81AF",
        "#38A0D9",
        "#6EC8FA",
        "#93D1FF",
        "#B7E2FF",
        "#E4F3FF",
      ];

      const lightningSum = response.data.map((e, i) => {
        return {
          y: e.sumCity,
          name: e.locationName,
          sliced: i == 0 ? true : false,
          color: lightnigColor[i],
          sumData: e.sumCity,
          datetime: e.datetime,
        };
      });

      lightningSum.type = "city";
      commit("setLightnigCountData", lightningSum);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchHistoricalAgencyQtdeUc({ commit }, data) {
    try {
      const response = await historicalService.getAgencycopel({
        regionalIds: [data],
      });

      commit("setHistoricalAgencyQtdeUc", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchHistoricalRegionalQtdeUc({ commit }) {
    try {
      const response = await historicalService.getRegionalCopel({
        regionalIds: [],
      });

      commit("setHistoricalRegionalQtdeUc", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchListCities({ commit }) {
    try {
      const response = await historicalService.getCityCopel({
        regionalIds: [],
        agencyIds: [],
        locationIds: [],
      });

      commit("setListCities", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchRegionalCitiesDailySummary({ commit }, data) {
    try {
      const response = await historicalService.getRegionalCitiesDailySummary({
        startDate: data.startDate,
        endDate: data.endDate,
        regionalId: data.id,
      });

      commit("setRegionalCitiesDailySummary", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchAgencylCitiesDailySummary({ commit }, data) {
    try {
      const response = await historicalService.getAgencyCitiesDailySummary({
        startDate: data.startDate,
        endDate: data.endDate,
        agencyId: data.id,
      });

      commit("setRegionalCitiesDailySummary", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchRegionalCitiesHourlySummary({ commit }, data) {
    try {
      const response = await historicalService.getRegionalCitiesHourlySummary({
        startDatetime: data.startDatetime,
        endDatetime: data.endDatetime,
        regionalId: data.id,
      });

      commit("setRegionalCitiesDailySummary", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchAgencylCitiesHourlySummary({ commit }, data) {
    try {
      const response = await historicalService.getAgencyCitiesHourlySummary({
        startDatetime: data.startDatetime,
        endDatetime: data.endDatetime,
        agencyId: data.id,
      });

      commit("setRegionalCitiesDailySummary", response.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },

  async fetchWeatherAgenciesOnAlertsTableData({ commit }, data) {
    try {
      let initialDate = null;
      let finalDate = null;
      const regionalId = data.location.id;
      if (data.periodId == 1) {
        initialDate = moment(data.startDate)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        finalDate =
          data.startDate == data.endDate
            ? moment(data.startDate)
                .utc()
                .add(1, "days")
                .format("YYYY-MM-DD[T]HH:mm:ss[Z]")
            : moment(data.endDate).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      }

      if (data.periodId == 2) {
        initialDate = moment(data.date)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        finalDate = moment(data.date)
          .utc()
          .add(1, "days")
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      }

      const response = await weatherService.getHistoricalAgenciesOnAlerts(
        regionalId,
        initialDate,
        finalDate
      );

      const response2 = await weatherService.getHistoricalWeatherAlerts(
        regionalId,
        initialDate,
        finalDate
      );

      commit("setWeatherAgenciesOnAlertsData", response.data);
      commit("setWeatherTableData", response2.data);
    } catch (error) {
      snackbar.show({
        type: "error",
        title: "Falhou",
        message: error.message,
        timeout: 3000,
      });
    }
  },
};

const getters = {
  historicalCountieData: (state) => state.historicalCountieData,
  weatherData: (state) => state.weatherData,
  recordedDataFromTelmetryStations: (state) =>
    state.recordedDataFromTelmetryStations,
  lightningCountData: (state) => state.lightningCountData,
  historicalRegionalData: (state) => state.historicalRegionalData,
  historicalAgencyData: (state) => state.historicalAgencyData,
  historicalAgencyQtdeUc: (state) => state.historicalAgencyQtdeUc,
  historicalRegionalQtdeUc: (state) => state.historicalRegionalQtdeUc,
  historicalFullData: (state) => state.historicalFullData,
  historicalFullRegional: (state) => state.historicalFullRegional,
  historicalForecastsData: (state) => state.historicalForecastsData,
  listCities: (state) => state.listCities,
  hsitoricalRegionalCitiesSummary: (state) =>
    state.hsitoricalRegionalCitiesSummary,
  weatherAgenciesOnAlertsData: (state) => state.weatherAgenciesOnAlertsData,
  weatherTableData: (state) => state.weatherTableData,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
